<template>
    <div id="StatisticsMap" class="w2 w90-mb">
        <svg id="taiwan-map" :viewBox="taiwanMap.viewBox">
            <g class="unknown" name="unknown">
                <path v-for="(item, index) of taiwanMap.unknownPath" :key="'unknown-path-' + index" :d="item" />
            </g>
            <g
                v-for="item of taiwanMap.g"
                :key="item.name"
                :name="item.name"
                :cityId="item.cityId"
                tabindex="0"
                role="button"
                @mouseover="changeActiveCity"
                @focus="changeActiveCity"
                @blur="activeCity = '臺灣'"
            >
                <path v-for="(subitem, subindex) of item.path" :key="item.name + '-' + subindex" :d="subitem" />
                <text :x="item.text.x" :y="item.text.y">
                    <tspan class="f24 f20-mb medium">
                        {{ item.text.tspan }}
                    </tspan>
                </text>
            </g>
        </svg>
        <div class="statistics-container">
            <ul class="data-group lh20">
                <li v-for="(value, key, index) of activeData" :key="key">
                    <h3 class="f16 f14-mb bold" :style="{ borderBottomColor: colorCode[index] }">
                        {{ key }}
                    </h3>
                    <p class="f24 f20-mb light">{{ value }} <span class="f14 f12-mb">公噸</span></p>
                </li>
            </ul>
            <ul class="data-source table">
                <li>
                    <span class="head">資料來源</span>
                    <span class="body">
                        環境部資源循環署<br />
                        海岸淨灘認養系統 淨灘成果彙整
                    </span>
                </li>
                <li>
                    <span class="head">更新日期</span>
                    <span class="body">
                        {{ `民國${updateDate.getFullYear() - 1911}年${updateDate.getMonth() + 1}月${updateDate.getDate()}日` }}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StatisticsMap',
}
</script>
<script setup>
import { computed, ref } from 'vue'
import getTaiwanMap from '@/data/getTaiwanMap'
import { getWasteSummary } from '@/service/apis.js'

const taiwanMap = getTaiwanMap()
// 取得 API 資料
const { statisticsData, updateDate } = await getWasteSummary()
const activeCity = ref('臺灣')
const activeData = computed(() => statisticsData[activeCity.value])
const colorCode = ['#E7B5B5', '#DCB690', '#E2D764', '#BCD7A1', '#AFCFDD', '#C0A899', '#BDB9B9']
function changeActiveCity(e) {
    e.currentTarget.focus()
    let cityId = e.currentTarget.getAttribute('cityId')
    activeCity.value = taiwanMap.g[cityId].text.tspan
}
</script>
<style lang="scss" scoped>
#StatisticsMap {
    display: flex;
    justify-content: center;
    align-items: center;
}
// 地圖樣式設定
svg#taiwan-map {
    flex: 0 0 40%;
    g {
        position: relative;
        z-index: 0;
        outline: transparent;
        path {
            stroke: $grayB;
            fill: transparent;
            transition: 0.3s;
        }
        tspan {
            fill: $theme0;
            transition: 0.3s;
        }
    }
    g:not(.unknown) {
        transition: 0.3s;
        cursor: pointer;
        &:hover,
        &:focus {
            z-index: 100;
            transform: translate(-5px, -5px);
            path {
                fill: $theme1;
            }
            tspan {
                fill: $theme3;
            }
        }
    }
}

// 右方資料列設定
.statistics-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-left: 3%;
    padding: 5% 0;
    flex: 1;
    .data-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        li {
            flex: 1 1 30%;
            margin: 1.5% 1%;
            padding: 15px;
            min-width: 150px;
            text-align: center;
            color: $gray6;
            background-color: $grayF;
            box-sizing: border-box;
            h3 {
                border-bottom: 3px solid;
            }
            p {
                margin-top: 0.5em;
            }
        }
    }
    .data-source {
        width: 330px;
    }
}

// 當螢幕寬度小於 960px 時改為上下顯示
@media screen and (max-width: 960px) {
    #StatisticsMap {
        flex-direction: column;
    }
    svg#taiwan-map {
        width: 100%;
        max-width: 500px;
    }
    .statistics-container {
        margin-left: 0;
    }
}
</style>
